import { Box, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { FilterContext } from "../context/FilterContext";
import { faSlidersH, faTimes } from "@fortawesome/pro-regular-svg-icons";
import LabelledButton from "./LabelledButton";
import { isMobile } from 'react-device-detect';

export default function FilterBar(){

    const filters=useContext(FilterContext);

    const [open, setOpen]=useState(false);

    return(
        <>
            <Box
                sx={{
                    zIndex:99999,
                    position:'absolute',
                    top:'1rem',
                    right:'1rem'
                }}
            >
                <LabelledButton
                    label='FILTERS'
                    icon={open? faTimes : faSlidersH}
                    background='rgb(0, 97, 117)'
                    color='#fff'
                    open={open}
                    onClick={()=>setOpen(!open)}
                />
            </Box>
            <Box
                sx={{
                    zIndex:9999,
                    position:'absolute',
                    top:0,
                    right: open? 0 : '-300px',
                    transition:'right 0.25s',
                    height:'100%',
                    width:'300px',
                    background: isMobile? 'rgba(0,0,0,0.85)' : 'rgba(0,0,0,0.65)',
                    color:'#fff',
                    display:'flex',
                    flexDirection:'column',
                    justifyContent: isMobile? 'unset' : 'center',
                    p:'2rem',
                    overflow:'scroll'
                }}
            >
                <Typography
                    sx={{
                        fontWeight:600,
                        fontSize: isMobile? '0.8rem' : '1rem'
                    }}
                >
                    FILTER BY
                </Typography>
                {filters.categories.map((category, i)=>{
                    //console.log(category)
                    return(
                        <FilterBtn
                            key={i}
                            img={category.icon?.url}
                            label={category.name}
                            active={filters.category === category.documentId}
                            onClick={() => {
                                filters.setCategory(filters.category===category.documentId? null : category.documentId);
                                filters.setBioRational(false);
                                filters.setIsSelection(false);
                            }}
                        />
                    );
                })}
                <FilterBtn
                    img='https://pub-909b5348287e470c9e1a5312eb777120.r2.dev/03_Biorational_green_1aeccd8ee4.png'
                    label='Biorational'
                    active={filters.bioRational}
                    onClick={() => {
                        filters.setCategory(null);
                        filters.setBioRational(!filters.bioRational);
                        filters.setIsSelection(filters.bioRational === true? false : null);
                    }}
                />
                <FilterBtn
                    label='All products'
                    active={filters.isSelection === false}
                    onClick={() => {
                        filters.setBioRational(false);
                        filters.setIsSelection(false);
                    }}
                />
                <FilterBtn
                    color='rgb(250, 166, 26)'
                    label='Selection'
                    active={filters.isSelection === true}
                    onClick={() => {
                        filters.setCategory(null);
                        filters.setBioRational(false);
                        filters.setIsSelection(true);
                    }}
                />
            </Box>
        </>
    );
}

function FilterBtn({ color='white', label, onClick, active, img }){

    return(
        <Box
            onClick={onClick}
            sx={{
                m:'1rem 0',
                display:'flex',
                alignItems:'center',
                cursor:'pointer',
                opacity: active? 1 : 0.5
            }}
        >
            {img?
                <img
                    src={img}
                    alt={label}
                    style={{
                        width: isMobile? '2.3rem' : '2.9rem'
                    }}
                />
            :
                <Box
                    sx={{
                        width: isMobile? '2rem' : '2.5rem',
                        minWidth: isMobile? '2rem' : '2.5rem',
                        height: isMobile? '2rem' : '2.5rem',
                        background:color,
                        borderRadius:'50%',
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center'
                    }}
                />
            }
            <Typography
                sx={{
                    ml:'1rem',
                    fontWeight:600,
                    fontSize: isMobile? '0.8rem' : '1rem'
                }}
            >
                {label}
            </Typography>
        </Box>
    );
}
